import styled from "@emotion/styled";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import { PageHeader } from "components/Common/Page";

export const ProductLaunchesPageContainer = styled.div({
	width: "100%",
	minWidth: 0,
	overflow: "hidden"
});

export const ProductLaunchesPageHeader = styled(PageHeader)({
	width: "100%",
	padding: "20px 32px"
});

export const ProductLaunchesPageContent = styled.div({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	gap: 24,
	padding: "12px 12px 24px",
	minWidth: 0
});

export const LaunchesGrid = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
	gap: 12,
	width: "100%",
	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
	},
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "minmax(0, 1fr)"
	}
}));

export const LaunchCardRoot = styled.article(({ theme }) => ({
	position: "relative",
	display: "flex",
	flexDirection: "column",
	minWidth: 0,
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: theme.project.borders.presets.thinOutline,
	transition: "box-shadow 0.2s ease",
	"&:hover, &:focus-within": {
		boxShadow: "0 2px 8px rgba(0, 0, 0, 0.16)"
	}
}));

const launchCardImageSize = {
	display: "block",
	width: "100%",
	aspectRatio: "2 / 1"
} as const;

export const LaunchCardImage = styled.img({
	...launchCardImageSize,
	objectFit: "cover"
});

export const LaunchCardImagePlaceholder = styled.div(({ theme }) => ({
	...launchCardImageSize,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	color: theme.project.colors.allColors.hex.grayscale.gray500
}));

export const LaunchCardPlaceholderIcon = styled(ImageNotSupportedOutlinedIcon)({
	fontSize: 48
});

export const LaunchCardBody = styled.div({
	display: "flex",
	flex: 1,
	flexDirection: "column",
	gap: 6,
	padding: "16px 12px 14px"
});

export const LaunchCardHeading = styled.h2<{ isLink: boolean }>(({ theme, isLink }) => ({
	...theme.project.typography.body.body1,
	margin: 0,
	fontWeight: 500,
	color: isLink ? theme.project.colors.primaryColors.main : theme.project.colors.fontColors.main,
	overflowWrap: "anywhere"
}));

/** The whole card is clickable: the link stretches over the card while staying the only tab stop. */
export const LaunchCardLink = styled.a({
	color: "inherit",
	textDecoration: "none",
	"&::after": {
		content: '""',
		position: "absolute",
		inset: 0
	},
	"&:hover": {
		textDecoration: "underline"
	}
});

export const LaunchCardSubtitle = styled.p(({ theme }) => ({
	...theme.project.typography.body.body2,
	margin: 0,
	color: theme.project.colors.fontColors.secondary,
	overflowWrap: "anywhere"
}));

export const LaunchCardDate = styled.span(({ theme }) => ({
	...theme.project.typography.caption,
	marginTop: "auto",
	paddingTop: 16,
	color: theme.project.colors.fontColors.tertiary
}));
